var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "syf-component-library/ui/spacing";
import getTranslation from "../../../strings/getTranslations";
import { useConfig } from "../../../hooks/useConfig";
import { IMAGE_ASSETS } from "../../../const/assets";
import { StatusMessage } from "../../atoms/StatusMessage";
var IncomeCaptureSuccess = function () {
    var profileConfig = useConfig();
    var assets = profileConfig.hosts.assets;
    var t = getTranslation().t;
    var successImage = "".concat(assets).concat(IMAGE_ASSETS.CLAPPING_HANDS);
    return (_jsxs(StatusMessage.Container, { children: [_jsx(StatusMessage.Image, { src: successImage, alt: "" }), _jsx(Stack, { size: "xlarge" }), _jsx(StatusMessage.TextBlock, __assign({ size: 20, weight: "semiBold" }, { children: t("incomeCapture.success.title") })), _jsx(Stack, { size: "large" }), _jsx(StatusMessage.TextBlock, __assign({ size: 14 }, { children: t("incomeCapture.success.subtitle") }))] }));
};
export default IncomeCaptureSuccess;
